import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants } from "../../src/utils";

const {
  class: { WK_KEYWORD_REF },
  command: { CLICK, KEYWORD_DEFINITION },
  KEYWORD_ATTRIBUTE: { KEYWORD_TYPE_OF },
  linksTo,
  localStorageItem: { baseHrefForLinkPlugin },
  htmlElement: { KEYWORD_SPAN },
} = CkeditorConstants;

export default class KeywordDefinitionCommand extends Command {
  /*
  Description: Inserts a keyword element span in editor
  Params: Object of label id, key word and definition id of the keyword
  */
  execute({ defId, data, labelId, resourceUrl }) {
    this.editor.model.change((writer) => {
      const docSelection = this.editor.model.document.selection;
      let documentFragment;
      if (data) {
        documentFragment = writer.createDocumentFragment();
        for (const selection of data.anchor.parent.getChildren()) {
          const clone = writer.cloneElement(selection);
          writer.append(clone, documentFragment);
        }
      } else {
        documentFragment = this.getSelectedContent(writer);
      }
      writer.remove(this.editor.model.document.selection.getFirstRange());
      const baseHref = this.editor.baseHrefForLinkPlugin;
      const keywordSpan = writer.createElement(KEYWORD_SPAN, {
        id: labelId,
        about: `${baseHref}#${labelId}`,
        rel: linksTo,
        typeof: KEYWORD_TYPE_OF,
        class: WK_KEYWORD_REF,
        resource: `${resourceUrl}/${defId}`,
      });
      writer.append(documentFragment, keywordSpan);
      this.editor.model.insertContent(keywordSpan, docSelection);
    });
    this.editor.focus();
    this.editor.fire(KEYWORD_DEFINITION);
    this.isEnabled = false;
    this.refresh();
  }

  getSelectedContent(writer) {
    const content = this.editor.data.stringify(
      this.editor.model.getSelectedContent(this.editor.model.document.selection)
    );
    const viewFragment = this.editor.data.processor.toView(content);
    const modelFragment = this.editor.data.toModel(viewFragment);
    for (let item of modelFragment.getChildren()) {
      writer.unwrap(item)
    }
    return modelFragment;
  }

  refresh() {
    this.listenTo(this.editor.editing.view.document, CLICK, () => {
      this.isEnabled =
        this.editor.model.document.selection.getSelectedElement() === null;
    });
  }
}
